// Fired on window whenever sign-in or sign-out completes, so every UI surface
// showing auth state (AuthWidget, landing's header) can re-render without
// polling. Shared here rather than re-declared per consumer, since it's both
// dispatched (profile.ts, oauth.ts) and listened for (ui-shell, landing) in
// more than one package.
export const BN_AUTH_CHANGE = 'bn_auth_change';
